import { withResult } from 'feathers-fletching';
import { validateSchema } from 'straightline-utils/hooks';

const withResults = withResult({
  pickup_address: (shipment) => {
    if (shipment.pickup_address) {
      return {
        ...shipment.pickup_address,
        position: {
          lat: Number(shipment.pickup_address.latitude),
          lng: Number(shipment.pickup_address.longitude)
        }
      };
    }
  },
  delivery_address: (shipment) => {
    if (shipment.delivery_address) {
      return {
        ...shipment.delivery_address,
        position: {
          lat: Number(shipment.delivery_address.latitude),
          lng: Number(shipment.delivery_address.longitude)
        }
      };
    }
  }
});

export default {
  before: {
    all: [],
    find: [],
    get: [],
    create: [validateSchema],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [withResults],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
};
